export default __webpack_public_path__ + "static/youtube-colored-469aab533ed23244d4a8640737f725f3.svg";